import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { TextArea, useLocalizeMessage } from 'libs.nucleus';
import { ValidatedTemplateNameInput } from './validated_template_name_input.component';
import { DataTransferTemplateContext } from '../../../contexts/data_transfer_template/data_transfer_template.context';
export const CloneTransferTemplateStep3 = () => {
    const translate = useLocalizeMessage();
    const { createTemplateFormData, setCreateTemplateFormData, setIsCreateFormValid } = useContext(DataTransferTemplateContext);
    const [templateName, setTemplateName] = useState(createTemplateFormData.name || '');
    const [templateDescription, setTemplateDescription] = useState(createTemplateFormData.description || '');
    const [isNameValid, setIsNameValid] = useState(true);
    // Update local state when context data changes
    useEffect(() => {
        setTemplateName(createTemplateFormData.name || '');
        setTemplateDescription(createTemplateFormData.description || '');
    }, [createTemplateFormData.name, createTemplateFormData.description]);
    // Update form validity based on name validity and non-emptiness
    useEffect(() => {
        setIsCreateFormValid(isNameValid && templateName.trim() !== '');
    }, [isNameValid, templateName, setIsCreateFormValid]);
    // Update both local state and context when fields change
    const handleNameChange = (value) => {
        setTemplateName(value);
        setCreateTemplateFormData({
            ...createTemplateFormData,
            name: value,
        });
    };
    const handleNameValidationChange = (isValid) => {
        setIsNameValid(isValid);
    };
    const handleDescriptionChange = (e) => {
        const { value } = e.target;
        setTemplateDescription(value);
        setCreateTemplateFormData({
            ...createTemplateFormData,
            description: value,
        });
    };
    return (_jsx("div", { className: 'flex flex-col items-center justify-center size-full', children: _jsxs("div", { className: 'min-w-[50%] space-y-4', children: [_jsx("div", { className: 'text-lg font-semibold', children: translate('Change information for the cloned template') }), _jsx(ValidatedTemplateNameInput, { value: templateName, onChange: handleNameChange, onValidationChange: handleNameValidationChange, id: 'template-name', required: true }), _jsx(TextArea, { label: translate('Description'), value: templateDescription, onChange: handleDescriptionChange, rows: 5, placeholder: translate('For data transfer but not for site archival'), id: 'template-description', width: 'full' })] }) }));
};
